import { useEffect, useState } from 'react';
import { apiClient } from '../lib/api.js';

interface Props {
  snapshotId: string | null;
  alt: string;
  className?: string;
}

export function SnapshotImage({ snapshotId, alt, className = '' }: Props) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!snapshotId) return;
    let objectUrl: string | null = null;
    let cancelled = false;

    apiClient
      .getBlob(`/api/v1/snapshots/${snapshotId}`)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [snapshotId]);

  if (!snapshotId) {
    return (
      <div
        className={`flex items-center justify-center bg-surface-container text-on-surface-variant text-xs rounded ${className}`}
      >
        No photo
      </div>
    );
  }
  if (error) {
    return (
      <div
        className={`flex items-center justify-center bg-surface-container text-on-surface-variant text-xs rounded ${className}`}
      >
        Photo unavailable
      </div>
    );
  }
  if (!src) {
    return <div className={`bg-surface-container-high animate-pulse rounded ${className}`} />;
  }
  return <img src={src} alt={alt} className={`object-cover rounded ${className}`} />;
}
